import * as React from 'react';
import * as styles from "./Wizard.css";
import { Helper } from '../../../Helper';
import { ContentOrganizerStore } from '../stores';
import { ESC_KEY_CODE } from '../../../global/Constants';
import { Swipeable } from "react-swipeable";
import { inject, observer } from 'mobx-react';

export interface IWizardProps {
  contentOrganizerStore?: ContentOrganizerStore;
  title?: string;
  open: boolean;
  transition: "slide" | "fade";
  width: number;
  highlightColor?: string;
  isMobile?: boolean;
  overlayColor?: string;
  // Callbacks
  close: () => void;
  onCancel?: () => void;
  disableESCFunction?: boolean;
}

export interface IWizardState {
  opacity: number;
  appendedToBody: boolean;
}

@inject('contentOrganizerStore')
@observer
export class IAWizard extends React.Component<IWizardProps, IWizardState> {
  private panelId;
  private ref = React.createRef<any>();

  constructor(props: IWizardProps) {
    super(props);
    this.state = {
      opacity: 1,
      appendedToBody: true,
    }

    this.panelId = Helper.getRandomStringKey();
  }

  public componentDidMount(): void {
    document.addEventListener("keydown", (event) => this.escFunction(event), false);
    window.addEventListener('resize', () => this.render());
    setTimeout(() => {
      this.render();
    }, 0);
    try {
      var resizeObserver = new ResizeObserver(() => {
        this.render();
      });
      resizeObserver.observe(document.getElementById(`panelId_${this.panelId}`));
    } catch {
      this.render();
    }
  }

  public componentWillUnmount(): void {
    document.removeEventListener("keydown", (event) => this.escFunction(event), false);
  }

  private hidePanel(): void {
    document.body.style.overflowY = "auto";
    document.body.style.height = "inherit";
  }

  public componentWillReceiveProps(props: IWizardProps): void {
    if (props.open) {
      document.body.style.overflowY = "hidden";
      document.body.style.height = "100vh";
    }
  }

  private escFunction(event: KeyboardEvent): void {
    if (event.keyCode === ESC_KEY_CODE && !this.props.disableESCFunction) {
      this.props.close != undefined ? this.props.close() : {};
      this.hidePanel();
    }
  }

  public render(): JSX.Element {
    let style;
    style = {
      right: this.props.open ? 0 : -(this.props.width + 50),
      transition: this.props.transition == "slide" ? `right 200ms ease-in-out` : `opacity 200ms ease-in-out`,
      width: this.props.width,
      marginTop: 0,
      height: "100%"
    }
    return (
      <div
        id={`panelId_${this.panelId}`}
        style={{
          display: this.state.appendedToBody ? "block" : "none",
        }}
      >
        <Swipeable
        >
          <div
            className={styles.panelWrapper}
            style={{
              visibility: this.props.open ? "visible" : "hidden",
              backgroundColor: this.props.overlayColor ? this.props.overlayColor : "rgba(255, 255, 255, 0.24)"
            }}
            onClick={() => {
              this.props.onCancel();
            }}
          />
          <div
            className={styles.slimPanel}
            style={style}
          >
            <div
              className={styles.slimPanelContentArea}
              id={`slimPanelContentArea-${this.panelId}`}
              style={{
                backgroundColor: "#fff",
                top: 0,
                height: "100%"
              }}
              ref={this.ref}
            >
              <div
                className={styles.header}
                style={{
                  opacity: this.state.opacity,
                  transition: "opacity 200ms"
                }}>
                {this.props.title != undefined &&
                  <div className={styles.title}>
                    <h1>{this.props.title}</h1>
                  </div>
                }
              </div>
              <div
                className={styles.content}
                style={{
                  opacity: this.state.opacity,
                  transition: "opacity 200ms"
                }}
              >
                {this.props.children}
              </div>
            </div>

          </div>
        </Swipeable>
      </div>
    );
  }
}